import { Funnel } from '@ant-design/plots';
import React from 'react';
import { createRoot } from 'react-dom/client';
import PlotAutoFit from '../Layout/PlotAutoFit';
import { myPalette } from '../Layout/Palettes';

const FunnelChart = () => {
  const data = [
    { stage: 'item1', number: 253 },
    { stage: 'item2', number: 151 },
    { stage: 'item3', number: 113 },
    { stage: 'item4', number: 87 },
    { stage: 'item5', number: 59 },
  ];

  const config = {
    data,
    xField: 'stage',
    yField: 'number', 
    label: { 
      text: (d:any) => `${d.stage}\n${d.number}`,
    },
 scale: {
      color: {
        palette: myPalette.palette,
        offset: (t: any) => t * 0.8 + 0.1,
      },
    },
     legend: {
          color: {
            title: true,
            position: "left",
            orientation: "horizontal",
            rowPadding: 10,
            itemMarker: "circle",
            itemMarkerSize: 18,
            itemMarkerLineWidth: 2,
            itemLabelFill: myPalette.labelCollor,
            itemLabelFontSize: 12,
            itemLabelFontWeight: 500,
            itemLabelPosition: "right",
            itemBackgroundFill: myPalette.backCollor,
            itemBackgroundRadius: 10,
            itemBackgroundStroke: "rgba(0, 0, 0, 0.35)",
            itemBackgroundLineWidth: 1,
            layout: {
              justifyContent: "flex-start",
              alignItems: "flex-start",
            },
          },
        },
  };

  return (
 <PlotAutoFit>
      {({ width, height }) => (
        <Funnel
          {...config}
          autoFit={false}
          width={width}
          height={height}
        />
      )}
      
    </PlotAutoFit>
 
  );
};
export default FunnelChart; 